import { useEffect } from 'react';
import { Theme, useTheme } from '@mui/material/styles';

function flattenPalette(obj: object, prefix = '--palette'): Record<string, string> {
  const vars: Record<string, string> = {};
  Object.entries(obj).forEach(([key, val]) => {
    if (typeof val === 'string') {
      vars[`${prefix}-${key}`] = val;
    } else if (typeof val === 'object' && val !== null) {
      Object.assign(vars, flattenPalette(val, `${prefix}-${key}`));
    }
  });
  return vars;
}

function setCssVariablesOnRoot(vars: Record<string, string>) {
  const styleId = 'dynamic-css-vars-root';
  let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }
  const cssVars = Object.entries(vars)
    .map(([key, val]) => `${key}: ${val};`)
    .join('\n  ');
  styleTag.textContent = `:root {\n  ${cssVars}\n}`;
}

export function useSyncCssVars(theme: Theme) {
  useEffect(() => {
    const vars = flattenPalette(theme.palette);
    setCssVariablesOnRoot(vars);
  }, [theme]);
}
